 
import React from 'react';
import {sizeGuideInformation} from '../HelperFunctions';

const SizeGuide = ({type}) => {
    const guide = sizeGuideInformation.find(guide => guide.id.toLowerCase() === type.toLowerCase());

    return (
        <>
            {guide && (
                <div className="size-guide-content">
                    <div className="size-guide-name">{guide.name}</div>
                    <img className="size-guide-image" src={`${guide.image}`} alt={`Size guide for ${guide.name}`} />
                    {guide.measureA && (
                        <div className="size-guide-measurements">
                            <div className="measurement-guide first-measurement">A</div>
                            <div className="measurement-instructions">{guide.measureA}</div>
                        </div>
                    )}
                    {guide.id === 'cheekpiece' && (
                        <div className="size-guide-note">
                            Make sure to take your bit into account when selecting a size - taller bits (such as pelhams
                            or elevators) will require shorter cheek pieces to sit correctly in your horse&apos;s mouth.
                        </div>
                    )}
                    {guide.measureB && (
                        <div className="size-guide-measurements">
                            <div className="measurement-guide second-measurement">B</div>
                            <div className="measurement-instructions">{guide.measureB}</div>
                        </div>
                    )}

                    <div className="size-chart-title">{guide.name} Size Chart</div>
                    <table className="table" data-ignoretable="true">
                        <caption className="sr-only">Size Chart</caption>
                        <thead>
                            <tr>
                                <th>Size</th>
                                <th>Length A</th>
                                {guide.measureB && <th>Length B</th>}
                            </tr>
                        </thead>
                        <tbody className="size-chart">
                            <tr className="pony-size">
                                <td>Pony</td>
                                <td>{guide.pony.lengthA}</td>
                                {guide.measureB && <td>{guide.pony.lengthB}</td>}
                            </tr>
                            <tr className="cob-size">
                                <td>Cob</td>
                                <td>{guide.cob.lengthA}</td>
                                {guide.measureB && <td>{guide.cob.lengthB}</td>}
                            </tr>
                            <tr className="full-size">
                                <td>Full</td>
                                <td>{guide.full.lengthA}</td>
                                {guide.measureB && <td>{guide.full.lengthB}</td>}
                            </tr>
                            <tr className="oversize-size">
                                <td>Oversize</td>
                                <td>{guide.oversize.lengthA}</td>
                                {guide.measureB && <td>{guide.oversize.lengthB}</td>}
                            </tr>
                        </tbody>
                    </table>
                </div>
            )}
        </>
    );
};

export default SizeGuide;
